import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { IAppConfig } from '../models/core/app-config';
import { AppConfigService } from '../services/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class RouteGuard implements CanActivate {
  constructor(private appConfigService: AppConfigService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve) => {
      this.appConfigService.getAppConfig().subscribe((data: IAppConfig) => {
        resolve(!data.enableChatRouteOnly);
      });
    });
  }
}
